import { StyleSheet, css } from 'aphrodite'
import React from 'react'

interface LandingCardProps {
  number: number
  title: string
  description: string
  backgroundColor: string
}

export default function LandingCard({
  number,
  title,
  description,
  backgroundColor,
}: LandingCardProps) {
  return (
    <div className={css(styles.card)} style={{ backgroundColor }}>
      <div className={css(styles.numberCircle)}>
        <span className={css(styles.number)}>{number}</span>
      </div>
      <h3 className={css(styles.title)}>{title}</h3>
      <p className={css(styles.description)}>{description}</p>
    </div>
  )
}

const styles = StyleSheet.create({
  card: {
    borderRadius: '16px',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    color: '#1F3D61',
    maxWidth: '100%',
    width: '100%',
    minHeight: '300px',
    '@media (min-width: 768px)': {
      borderRadius: '20px',
      padding: '32px 30px',
      maxWidth: '48%',
      minHeight: '350px',
    },
    '@media (min-width: 1024px)': {
      borderRadius: '24px',
      padding: '40px 40px',
      maxWidth: '30%',
      minHeight: '400px',
    },
  },
  numberCircle: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    flexShrink: 0,
    alignSelf: 'center',
    '@media (min-width: 768px)': {
      width: '66px',
      height: '66px',
      alignSelf: 'flex-start',
    },
    '@media (min-width: 1024px)': {
      width: '72px',
      height: '72px',
    },
  },
  number: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1F3D61',
    '@media (min-width: 768px)': {
      fontSize: '26px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '28px',
    },
  },
  title: {
    fontFamily: '"Anton", sans-serif',
    fontSize: '28px',
    lineHeight: 1.1,
    fontWeight: 400,
    color: '#1F3D61',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      fontSize: '36px',
      textAlign: 'left',
    },
    '@media (min-width: 1024px)': {
      fontSize: '48px',
    },
  },
  description: {
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#1F3D61',
    textAlign: 'center',
    fontWeight: 400,
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    '@media (min-width: 768px)': {
      fontSize: '16px',
      textAlign: 'left',
    },
    '@media (min-width: 1024px)': {
      fontSize: '18px',
    },
  },
})
